import { useFetchOrganizationCoworkers } from "@core/features/organization";
import { Loader } from "@themes/pollinator/ui/Loader";
import { CoworkersTable, type TeamMember } from "./CoworkersTable";

export type Props = {
  organizationId: number;
};

/**
 * Container for CoworkersTable.
 * Fetches organization coworkers (active admins + pending invitations).
 */
export function CoworkersTableContainer({ organizationId }: Props) {
  const { data: coworkers, isLoading } = useFetchOrganizationCoworkers({
    organizationId,
    enabled: !!organizationId,
  });

  if (isLoading) {
    return <Loader />;
  }

  if (!coworkers) {
    return null;
  }

  const teamMembers: TeamMember[] = coworkers.map((coworker) => ({
    id: coworker.id,
    name: coworker.name,
    email: coworker.email,
    status: coworker.status,
    isExpired: coworker.is_expired,
  }));

  return <CoworkersTable teamMembers={teamMembers} />;
}

export default CoworkersTableContainer;
